"use strict";


var siindex = document.querySelector(".index");
if (siindex) {
    var music = document.getElementById("background-music");
    var voice = document.getElementById("voice-audio");
    var checkBox = document.querySelector("input[type=checkbox]");
    var introContent = document.querySelector(".intro__content");

    // Initialisation des volumes
    music.volume = 0.3;
    voice.volume = 0.7;

    // Au chargement, checkbox décochée et pas de son lancé
    checkBox.checked = false;
    music.pause();
    voice.pause();

    // Sauvegarde de l'état (pour garder cohérence, sinon on peut virer)
    var isPlaying = localStorage.getItem("musicPlaying") || "false";

    // Met à jour la checkbox selon la valeur locale (optionnel)
    checkBox.checked = (isPlaying === "true");

    // Si la checkbox est cochée (par la sauvegarde), on attend une interaction pour jouer la musique
    function initializeMusic() {
        if (checkBox.checked) {
            // Attendre une interaction utilisateur avant de jouer la musique
            document.body.addEventListener("click", () => {
                music.play().catch(err => console.log("Impossible de jouer la musique automatiquement :", err));
            }, { once: true });
        }
    }

    // Ecoute changement checkbox
    checkBox.addEventListener("change", () => {
        if (checkBox.checked) {
            music.play().catch(err => console.log("Impossible de jouer la musique :", err));
        } else {
            music.pause();
            voice.pause();
        }
        localStorage.setItem("musicPlaying", checkBox.checked);
    });

    // Fonction pour jouer la voix uniquement si checkbox cochée
    function playVoice() {
        if (checkBox.checked) {
            voice.play().catch(err => console.log("Le son de la voix n'a pas pu être joué :", err));
        }
    }

    // Quand l'animation est finie, lancer la voix (si checkbox cochée)
    introContent.addEventListener("animationend", (event) => {
        if (event.animationName === "content") {
            setTimeout(playVoice, 1000);
        }
    });

    initializeMusic();

    // Icônes pour toggler le son (si elles existent)
    const iconSoundOn = document.querySelector(".toggle-sound-on");
    const iconSoundOff = document.querySelector(".toggle-sound-off");

    if (iconSoundOn) {
        iconSoundOn.addEventListener("click", () => {
            if (!checkBox.checked) {
                checkBox.checked = true;
                checkBox.dispatchEvent(new Event("change"));
            }
        });
    }

    if (iconSoundOff) {
        iconSoundOff.addEventListener("click", () => {
            if (checkBox.checked) {
                checkBox.checked = false;
                checkBox.dispatchEvent(new Event("change"));
            }
        });
    }
}



var siChap = document.querySelector(".chapitre");
// if (siChap) {
//     document.addEventListener("DOMContentLoaded", () => {
//         var music = document.querySelector("audio"); // Trouve l'élément audio
//         var checkBox = document.querySelector(".sources__switch input"); // Trouve l'interrupteur
            
//         if (!music) {
//             console.log("⚠️ Aucun élément audio trouvé sur cette page.");
//             return;
//         }
//         if (!checkBox) {
//             console.log("⚠️ Aucun interrupteur trouvé sur cette page.");
//             return;
//         }
    
//         console.log("🎵 Audio détecté :", music.src);
    
//         music.volume = 0.3; // Définit le volume de l'audio
    
//         // Récupère l'état de la musique sauvegardé dans le localStorage
//         var isPlaying = localStorage.getItem("musicPlaying");
    
//         // Applique l'état sauvegardé ou joue la musique par défaut
//         if (isPlaying === "false") {
//             music.pause();
//             checkBox.checked = false;
//             console.log("⏸️ Musique en pause au chargement");
//         } else {
//             music.play().catch((err) => console.log("⚠️ Erreur lors de la lecture :", err));
//             checkBox.checked = true;
//             console.log("▶️ Musique en lecture au chargement");
//         }
    
//         // Gestion du toggle
//         checkBox.addEventListener("change", () => {
//             if (checkBox.checked) {
//                 music.play().catch((err) => console.log("⚠️ Erreur lors de la lecture :", err));
//                 console.log("🎵 Musique jouée");
//             } else {
//                 music.pause();
//                 console.log("⏸️ Musique mise en pause");
//             }
//             localStorage.setItem("musicPlaying", checkBox.checked);
//         });
//     });   
    
// }
if (siChap) {
    document.addEventListener("DOMContentLoaded", () => {
        const music = document.querySelector("audio");
        const checkBox = document.querySelector(".sources__switch input");
        const iconMute = document.querySelector(".fa-volume-xmark");
        const iconSound = document.querySelector(".fa-volume-high");

        if (!music || !checkBox) {
            console.log("⚠️ Éléments audio ou interrupteur non trouvés.");
            return;
        }

        music.volume = 0.3;

        // Récupère l'état sauvegardé (si aucune valeur, musique désactivée)
        const isPlaying = localStorage.getItem("musicPlaying");

        // ✅ Musique coupée par défaut
        if (isPlaying === "true") {
            checkBox.checked = true;
            music.play().catch((err) => console.log("⚠️ Erreur de lecture :", err));
            console.log("▶️ Musique activée (préférence utilisateur)");
        } else {
            checkBox.checked = false;
            music.pause();
            console.log("⏸️ Musique désactivée par défaut");
        }

        // Gestion de l'interrupteur
        checkBox.addEventListener("change", () => {
            if (checkBox.checked) {
                music.play().catch((err) => console.log("⚠️ Erreur de lecture :", err));
                console.log("🎵 Musique jouée");
            } else {
                music.pause();
                console.log("⏸️ Musique mise en pause");
            }
            localStorage.setItem("musicPlaying", checkBox.checked);
        });

        // Gestion des icônes : simulation de clic sur l'interrupteur
        const simulateToggle = () => {
            checkBox.checked = !checkBox.checked;
            checkBox.dispatchEvent(new Event("change"));
        };

        iconMute?.addEventListener("click", simulateToggle);
        iconSound?.addEventListener("click", simulateToggle);
    });
}




var siSalle1 = document.querySelector('.salle1');
if (siSalle1) {

    // window.addEventListener('DOMContentLoaded', () => {
    //     const introVideos1 = document.getElementById("intro-video");
    //     const introContainers1 = document.getElementById("intro-video-container");
    //     let playCounts1 = 0;
  
    //     // Fonction pour afficher/masquer selon la largeur d'écran
    //     function toggleVideoDisplay() {
    //         if (window.innerWidth > 1000) {
    //             introContainers1.style.display = 'none';
    //         } else {
    //             introContainers1.style.display = 'flex'; // important pour respecter le CSS
    //         }
    //     }
  
    //     // Appel initial + écoute redimensionnement
    //     toggleVideoDisplay();
    //     window.addEventListener('resize', toggleVideoDisplay);
  
    //     // Lecture / disparition vidéo
    //     introVideos1.addEventListener("ended", () => {
    //         playCounts1++;
    //         if (playCounts1 >= 2) {
    //             introContainers1.style.transition = "opacity 1s ease";
    //             introContainers1.style.opacity = "0";
    //             setTimeout(() => {
    //                 introContainers1.remove();
    //             }, 1000);
    //         } else {
    //             introVideos1.play();
    //         }
    //     });
    // });
      

    function showCustomAlert(message) {
        const alertBox = document.querySelector('.customAlert');
        const alertMessage = document.querySelector('.customAlert__message');
        const okButton = document.querySelector('.customAlert__button');

        // Met à jour le message
        alertMessage.textContent = message;

        // Affiche l'alerte en enlevant la classe 'hidden'
        alertBox.classList.remove('hidden');

        // Fonction pour masquer l'alerte
        const hideAlert = () => {
            alertBox.classList.add('hidden');
        };

        // Délai automatique de 30 secondes (30000 ms)
        const timeoutId = setTimeout(hideAlert, 10000);

        // Événement de clic sur le bouton "Ok"
        okButton.addEventListener('click', () => {
            hideAlert(); // Masque l'alerte
            clearTimeout(timeoutId); // Annule le masquage automatique
        }, { once: true }); // Le listener ne s’exécute qu’une fois
    }




    //drag&drop cxhronologie
    const correctOrder = ['fireCart', 'DesCart', 'MonnaieCart', 'GoussetCart', 'lavelingeCart', 'morseCart', 'guitareCart'];
    let currentOrder = [...correctOrder];
    let firstSelectedIndex = null; // 🔹 Pour le clic-swap

    const salle1Container = document.getElementById('salle1Container');

    function shuffleArray(array) {
        return array.sort(() => Math.random() - 0.5);
    }

    function renderCards() {
        salle1Container.innerHTML = '';
        currentOrder.forEach((id, index) => {
            const card = document.createElement('div');
            card.className = 'dragula__card';
            card.setAttribute('data-index', index);
            card.setAttribute('draggable', true);

            const img = document.createElement('img');
            img.src = `assets/images/${getImageById(id)}`;
            img.alt = id;
            img.id = id;
            img.loading = "lazy";

            card.appendChild(img);
            salle1Container.appendChild(card);

            // 🔹 Drag events
            card.addEventListener('dragstart', (e) => {
                e.dataTransfer.setData('text/plain', index);
            });

            card.addEventListener('dragover', (e) => {
                e.preventDefault();
            });

            card.addEventListener('drop', (e) => {
                const fromIndex = e.dataTransfer.getData('text/plain');
                const toIndex = card.getAttribute('data-index');
                swapCards(fromIndex, toIndex);
            });

            // 🔹 Click to swap
            card.addEventListener('click', () => {
                const currentIndex = parseInt(card.getAttribute('data-index'));

                if (firstSelectedIndex === null) {
                    firstSelectedIndex = currentIndex;
                    card.classList.add('selected');
                } else {
                    swapCards(firstSelectedIndex, currentIndex);
                    const previouslySelected = document.querySelector('.dragula__card.selected');
                    if (previouslySelected) {
                        previouslySelected.classList.remove('selected');
                    }
                }
            });
        });
    }

    function swapCards(from, to) {
        [currentOrder[from], currentOrder[to]] = [currentOrder[to], currentOrder[from]];
        firstSelectedIndex = null; // 🔹 Réinitialise la sélection au clic
        renderCards();
    }

    function checkSuccess() {
        const isCorrect = currentOrder.every((id, i) => id === correctOrder[i]);
        if (isCorrect) {
            document.querySelectorAll(".colombnone").forEach(function(element) {
                element.classList.remove('none');
            });
            document.querySelector('.okchronos1').classList.add('next');
            openSuccessModal();
        } else {
            showCustomAlert("Mauvais ordre. Réessaye ! Un indice est dans la pièce pour t'aider.");
        }
    }

    function openSuccessModal() {
        const successModal = document.querySelector('.salle1__modal--success');
        if (successModal) {
            successModal.classList.add('visible');
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        currentOrder = shuffleArray([...correctOrder]);
        renderCards();

        const validateButton = document.querySelector('.valider-modal');
        validateButton.addEventListener('click', checkSuccess);
    });

    function getImageById(id) {
        switch(id) {
            case 'MonnaieCart': return 'monnaies1.webp';
            case 'morseCart': return 'morses1.webp';
            case 'guitareCart': return 'guitares1.webp';
            case 'GoussetCart': return 'goussets1.webp';
            case 'fireCart': return 'fires1.webp';
            case 'DesCart': return 'lesdess1.webp';
            case 'lavelingeCart': return 'lavelinges1.webp';
            default: return '';
        }
    }






    // === Armoire à livres ===
    const password = "COLOMB";
    const inputs = document.querySelectorAll(".password__input");
    const validateBtn = document.querySelector(".validate-password");
    const passContainer = document.querySelector(".password__container");
    const passContent = document.querySelector(".password__content");
    
    inputs.forEach((input, index) => {
        input.addEventListener("input", (e) => {
            e.target.value = e.target.value.toUpperCase(); // Force uppercase
            
            if (e.target.value && index < inputs.length - 1) {
                inputs[index + 1].focus(); // Move to next input
            }
        });
        
        input.addEventListener("keydown", (e) => {
            if (e.key === "Backspace" && !input.value && index > 0) {
                inputs[index - 1].focus(); // Move to previous input
            }
        });
    });
    
    validateBtn.addEventListener("click", () => {
        const enteredPassword = Array.from(inputs).map(input => input.value).join("");
        if (enteredPassword === password) {
            passContainer.style.display = "none";
            validateBtn.style.display = "none";
            passContent.classList.remove('none');

        } else {  
            showCustomAlert("Mot de passe incorrect. Réessaye !")
            inputs.forEach(input => input.value = "");
            inputs[0].focus(); // Reset and focus first input
        }
    });



    //coffre cadenas final salle 1
    const secretCode = ["8", "1", "2", "7", "9"];
    const digits = [0, 0, 0, 0, 0];

    const locks1 = document.querySelector('.lock');
    const lasts1 = document.querySelector('.lasts1');
    const unlocks1 = document.querySelector('#unlockButtonS1');
    const footers1 = document.querySelector('.modal__footer--s1');
    const footerends1 = document.querySelector('.modal__footer--ends1');

    // Fonction d'incrémentation
    function incrementDigit(index) {
        digits[index] = (digits[index] + 1) % 10; 
        document.getElementById(`digit${index}`).value = digits[index];
    }

    // Fonction de décrémentation
    function decrementDigit(index) {
        digits[index] = (digits[index] - 1 + 10) % 10; // Passe de 9 à 0, revient à 9
        document.getElementById(`digit${index}`).value = digits[index];
    }

    // Ajout des événements sur les boutons de modification des chiffres
    document.querySelectorAll(".arrowS1").forEach(button => {
        button.addEventListener("click", () => {
            const index = parseInt(button.dataset.index, 10); // Récupère l'index de l'input concerné
            if (button.classList.contains("up")) {
                incrementDigit(index);
            } else {
                decrementDigit(index);
            }
        });
    });

    // Vérification du code au clic sur le bouton "Déverrouiller"
    unlocks1.addEventListener("click", () => {
        const isCorrect = digits.every((digit, index) => digit.toString() === secretCode[index]);
        // const message = document.getElementById("message");

        if (isCorrect) {
            // message.textContent = "Cadenas déverrouillé !";
            // message.style.color = "green";
            lasts1.classList.remove("none");
            footerends1.classList.remove("none");
            locks1.classList.add("none"); 
            footers1.classList.add("none"); 
        } else {
            // message.textContent = "Code incorrect. Réessayez.";
            // message.style.color = "red";
            showCustomAlert("Le mot de passe est incorrect. Essaie encore, tu y es presque ! Utilise l'horloge...");

        }
    });
}


// var siChap2 = document.querySelector('.chapitre2');
var siSalle2 = document.querySelector('.salle2');
var siSalle3 = document.querySelector('.salle3');
var siSalle4 = document.querySelector('.salle4');
var siSalle5 = document.querySelector('.salle5');
var siSalle6 = document.querySelector('.ends6');
var silesChapitres = document.querySelectorAll('.chapitre');
if (silesChapitres) {
    const openModalButtons = document.querySelectorAll('.open-modal');
    const closeModalButtons = document.querySelectorAll('.close-modal');
    const nextButtons = document.querySelectorAll('.next');
    const validateButton = document.querySelector('.valider-modal');

    function openModal(event) {
        const trigger = event.currentTarget;
        const modalToOpen = trigger.nextElementSibling;
        if (modalToOpen && modalToOpen.classList.contains('modal')) {
            modalToOpen.classList.add('visible');
        } else {
            console.error('Aucune modale associée trouvée pour cet élément déclencheur.');
        }
    }

    function closeModal() {
        document.querySelectorAll('.modal.visible').forEach(modal => modal.classList.remove('visible'));
    }

    function openNextModal(event) {
        const currentModal = event.currentTarget.closest('.modal');
        if (!currentModal) return;
        
        const nextModal = currentModal.nextElementSibling;
        if (nextModal && nextModal.classList.contains('modal')) {
            currentModal.classList.remove('visible');
            nextModal.classList.add('visible');
        } else {
            console.error('Aucune modale suivante trouvée.');
        }
    }

    openModalButtons.forEach(btn => btn.addEventListener('click', openModal));
    closeModalButtons.forEach(btn => btn.addEventListener('click', closeModal));
    nextButtons.forEach(btn => btn.addEventListener('click', openNextModal));
}


if (siSalle2) {

    function showCustomAlert(message) {
        const alertBox = document.querySelector('.customAlert');
        const alertMessage = document.querySelector('.customAlert__message');
        const okButton = document.querySelector('.customAlert__button');
    
        // Met à jour le message
        alertMessage.textContent = message;
    
        // Affiche l'alerte en enlevant la classe 'hidden'
        alertBox.classList.remove('hidden');
    
        // Événement de clic sur le bouton "Ok"
        okButton.addEventListener('click', () => {
            // Masque l'alerte en ajoutant la classe 'hidden'
            alertBox.classList.add('hidden');
        });
    }

    // === Horloge de gauche ===
    const min = document.querySelector('.minute');
    const heure = document.querySelector('.heure');
    const incrementHeure = document.getElementById('increment-heure');
    const incrementMinute = document.getElementById('increment-minute');
    const valider = document.getElementById('valider');
    const messageHorlogeleft = document.querySelector('.clock-message');

    // Initialisation de l'heure et des minutes
    let heureDeg = 0;  // Heure à 12h (0°)
    let minDeg = 0;  // Minute à 0 (0°)

    // Applique les rotations initiales
    min.style.transform = `rotateZ(${minDeg}deg)`;
    heure.style.transform = `rotateZ(${heureDeg}deg)`;

    // Fonction pour avancer l'aiguille des heures
    incrementHeure.addEventListener('click', () => {
        heureDeg += 30;  // Avance l'aiguille des heures de 30° (1 heure)
        if (heureDeg >= 360) heureDeg = 0;  // Reprend à 0 après 12 heures
        heure.style.transform = `rotateZ(${heureDeg}deg)`;
    });

    // Fonction pour avancer l'aiguille des minutes
    incrementMinute.addEventListener('click', () => {
        minDeg += 30;  // Avance l'aiguille des minutes de 6° (1 minute)
        if (minDeg >= 360) minDeg = 0;  // Reprend à 0 après 60 minutes
        min.style.transform = `rotateZ(${minDeg}deg)`;
    });

    var nextUseKey = document.querySelector(".useKey");
    nextUseKey.style.display = 'none';
    
    let useKeyClicked = localStorage.getItem("useKeyClicked") === "true";

    var horlogeFermeeImg = document.querySelector("#horlogefermee");
    var nextLeft = document.querySelector(".nextLeft");
    nextLeft.style.display = 'none' ;
    // Fonction de validation de l'heure
    valider.addEventListener('click', () => {
        // Si l'heure est réglée sur 9h15 (270° et 90°)
        if ((heureDeg === 270 && minDeg === 90) || (heureDeg === 90 && minDeg === 270)) {

            nextUseKey.style.display = 'inline-block';
            nextLeft.style.display = 'inline-block'; 
            } else {
                messageHorlogeleft.textContent = "Essayez encore ! Pensez à comment est une balance en équilibre...";
                messageHorlogeleft.style.visibility = 'visible';
            }

        nextUseKey.addEventListener("click", () => {
            useKeyClicked = true;
            localStorage.setItem("useKeyClicked", "true"); // Sauvegarde de l'état
            horlogeFermeeImg.src = "assets/images/chapitres2/Upopen.webp";
        });

    });

    // element.style.marginTop = "50px";
    // message.style.animation = "rotate 6s linear infinite";



    // coffret engrenage
    var useGear = document.querySelector(".useGear");
    useGear.style.display = "none";
    document.querySelector("#validerCodeGear").addEventListener("click", function () {
        var codeInput = document.querySelector("#codeInput");
        var messageCode = document.querySelector("#messageCodeGears2");
        var gearImage = document.querySelector("#gearImageS2");
        var instruGear = document.querySelector(".instruGear");
        
    
        if (codeInput.value === "15") {
            // Cacher l'input et le bouton
            codeInput.style.display = "none";
            this.style.display = "none";
            instruGear.style.display = "none";
    
            // Afficher l'image et le message
            messageCode.style.display = "block";
            gearImage.style.display = "block";
            useGear.style.display = "inline-block";
        } else {
            // alert("Mauvais code, essayez encore !");
            showCustomAlert("Cette réponse n'est pas correcte. Concentre-toi !");
            gearImage.style.display = "none";
            useGear.style.display = "none";
        }
    });


    // montrer le post it si engrenages remis
    var postit = document.querySelector(".salle2__postitS2");
    document.querySelector("#postitS2Cache").style.display = "none";
    document.querySelector('#UtiliserGear').addEventListener("click", function () {
        postit.classList.remove('none');

        if (!postit.classList.contains('none')) {
            document.querySelector("#postitS2Cache").style.display = "block";
        }
    })


    // vérifier que le code mis est celui de l'année
    const anneeActuelleS2 = new Date().getFullYear();
    var lastcodes2 = document.querySelector("#codeInputLastS2");
    var lastnexts2 = document.querySelector("#lastNexts2");
    lastnexts2.style.display = "none";
   
    document.querySelector("#validerlastDesk").addEventListener("click", function () {
        if (parseInt(lastcodes2.value) === anneeActuelleS2) { 
            lastnexts2.style.display = "inline-block"; // Afficher si le code est correct
        } else {
            lastnexts2.style.display = "none"; // Rester caché si c'est faux
        }
    });
    

    //les clespydres
    const notes = {
        'do': new Audio('assets/sons/do.wav'),
        're': new Audio('assets/sons/re.wav'),
        'mi': new Audio('assets/sons/mi.wav')
    };
    
    const sequenceS2 = ['do', 'do', 'do', 're', 'mi', 're'];
    let userSequenceS2 = [];
    
    document.querySelector('.gameS2__play').addEventListener('click', () => {
        userSequenceS2 = [];
        document.querySelector('.gameS2__message').textContent = '';
        playSequenceS2(sequenceS2);
    });
    
    document.querySelector('.gameS2__reset').addEventListener('click', () => {
        userSequenceS2 = [];
        document.querySelector('.gameS2__message').textContent = 'Séquence réinitialisée.';
    });
    
    document.querySelectorAll('.glass').forEach(glass => {
        glass.addEventListener('click', (e) => {
            const note = e.target.dataset.note;
            playSound(note, e.target);
            userSequenceS2.push(note);
            checkSequenceS2();
        });
    });
    
    function playSound(note, element) {
        if (notes[note]) {
            notes[note].currentTime = 0;
            notes[note].play();
            animateGlass(element);
        }
    }
    
    function playSequenceS2(seq) {
        let delay = 0;
        seq.forEach((note, index) => {
            setTimeout(() => {
                const glass = document.querySelector(`.glass[data-note="${note}"]`);
                playSound(note, glass);
            }, delay);
            delay += 600;
        });
    }
    
    var recupS2 = document.querySelector("#RecupfragS2");
    recupS2.style.display="none";
    function checkSequenceS2() {
        const correctSequenceS2 = ['do', 'mi', 're', 're', 'do'];
        if (userSequenceS2.length === correctSequenceS2.length) {
            if (JSON.stringify(userSequenceS2) === JSON.stringify(correctSequenceS2)) {
                document.querySelector('.gameS2__message').textContent = 'Bravo ! Séquence correcte !';
                recupS2.style.display="inline-block";
            } else {
                document.querySelector('.gameS2__message').textContent = 'Essayez encore !';
            }
            userSequenceS2 = [];
        }
    }
    
    function animateGlass(glass) {
        glass.classList.add('active');
        setTimeout(() => {
            glass.classList.remove('active');
        }, 300);
    }

}

if (siSalle3) {


    function showCustomAlert(message) {
        const alertBox = document.querySelector('.customAlert');
        const alertMessage = document.querySelector('.customAlert__message');
        const okButton = document.querySelector('.customAlert__button');
    
        // Met à jour le message
        alertMessage.textContent = message;
    
        // Affiche l'alerte en enlevant la classe 'hidden'
        alertBox.classList.remove('hidden');
    
        // Événement de clic sur le bouton "Ok"
        okButton.addEventListener('click', () => {
            // Masque l'alerte en ajoutant la classe 'hidden'
            alertBox.classList.add('hidden');
        });
    }


    // lampe connectiques
    let connections = 0;
    let firstSelectedWire = null;

    const filImages = {
        red: document.querySelector(".lefil__red"),
        blue: document.querySelector(".lefil__blue"),
        green: document.querySelector(".lefil__green"),
        yellow: document.querySelector(".lefil__yellow"),
        purple: document.querySelector(".lefil__violet"),
        pink: document.querySelector(".lefil__pink")
    };

    // DRAG & DROP
    document.querySelectorAll(".wire[draggable=true]").forEach(wire => {
        wire.addEventListener("dragstart", (e) => {
            e.dataTransfer.setData("color", e.target.dataset.color);
        });

        // CLIC DE SÉLECTION - POINT DE DÉPART
        wire.addEventListener("click", () => {
            // pdd
            if (!firstSelectedWire) {
                firstSelectedWire = wire;
                wire.classList.add("selected");
            } else {
                // On clique à nouveau sur un autre départ : on change la sélection
                firstSelectedWire.classList.remove("selected");
                firstSelectedWire = wire;
                wire.classList.add("selected");
            }
        });
    });

    // ZONES D’ARRIVÉE
    document.querySelectorAll("#endPoints .wire").forEach(target => {
        target.addEventListener("dragover", (e) => {
            e.preventDefault();
        });

        target.addEventListener("drop", (e) => {
            e.preventDefault();
            const color = e.dataTransfer.getData("color");
            handleConnection(color, target);
        });

        // CLIC - POINT D’ARRIVÉE
        target.addEventListener("click", () => {
            if (firstSelectedWire) {
                const color = firstSelectedWire.dataset.color;
                handleConnection(color, target);
                firstSelectedWire.classList.remove("selected");
                firstSelectedWire = null;
            }
        });
    });

    // Fonction unique pour connecter
    function handleConnection(color, target) {
        if (color === target.dataset.color && target.style.opacity !== "0.3") {
            target.style.opacity = "0.3";
            connections++;

            // Afficher l'image du fil correspondant
            filImages[color].classList.remove("none");

            // Vérifier si toutes les connexions sont faites
            if (connections === 6) {
                document.querySelector(".gameelS3__message").innerHTML = "Bravo&nbsp;! Tu as réussi à connecter tous les fils";
                document.querySelector(".salle3__lampDeco").src = "assets/images/chapitres3/decolampS3bis.webp";
                document.querySelector(".salle3__lampDeco").style.width = "calc(3% + 50px)";
            }
        }
    }


    //coffret à piles
    const secretCode = ["4", "1", "5", "2"];
    const digits = [0, 0, 0, 0];

    const locks3 = document.querySelector('.lock');
    const lasts3 = document.querySelector('.lasts3');
    const unlocks3 = document.querySelector('#unlockButtonS3');
    const footers3 = document.querySelector('.modal__footer--s3');
    const footerends3 = document.querySelector('.modal__footer--ends3');

    // Fonction d'incrémentation
    function incrementDigit(index) {
        digits[index] = (digits[index] + 1) % 10; 
        document.getElementById(`digit3${index}`).value = digits[index];
    }

    // Fonction de décrémentation
    function decrementDigit(index) {
        digits[index] = (digits[index] - 1 + 10) % 10; // Passe de 9 à 0, revient à 9
        document.getElementById(`digit3${index}`).value = digits[index];
    }

    // Ajout des événements sur les boutons de modification des chiffres
    document.querySelectorAll(".arrowS1").forEach(button => {
        button.addEventListener("click", () => {
            const index = parseInt(button.dataset.index, 10); // Récupère l'index de l'input concerné
            if (button.classList.contains("up")) {
                incrementDigit(index);
            } else {
                decrementDigit(index);
            }
        });
    });

    document.querySelector('.UsePiles3').style.display="none";

    // Vérification du code au clic sur le bouton "Déverrouiller"
    unlocks3.addEventListener("click", () => {
        const isCorrect = digits.every((digit, index) => digit.toString() === secretCode[index]);
        // const message = document.getElementById("message");
        if (isCorrect) {
            // message.textContent = "Cadenas déverrouillé !";
            // message.style.color = "green";
            lasts3.classList.remove("none");
            footerends3.classList.remove("none");
            locks3.classList.add("none"); 
            footers3.classList.add("none"); 
            document.querySelector('.UsePiles3').style.display="inline-block";
        } else {
            // message.textContent = "Code incorrect. Réessayez.";
            // message.style.color = "red";
            // alert('Le mot de passe est incorrect. Essayez encore !');
            showCustomAlert("Le coffret ne s'ouvre pas. As-tu bien analysé TOUS les objets ?");
        }
    });


    // lampe de poche
    document.querySelector(".lamppoche").addEventListener("mousemove", function(event) {
        let oLight = document.querySelector(".lamppoche__light");
        let oDarkness = document.querySelector(".lamppoche__darkness");
        let containerLampe = document.querySelector(".lamppoche__container");
    
        if (!oLight || !oDarkness || !containerLampe) return;
    
        let containerRect = containerLampe.getBoundingClientRect();
    
        let eLightX = event.clientX - containerRect.left;
        let eLightY = event.clientY - containerRect.top;
    
        // Empêcher la lumière de sortir
        if (eLightX < 0 || eLightX > containerRect.width || eLightY < 0 || eLightY > containerRect.height) return;
    
        // Appliquer la position
        oLight.style.left = `${eLightX}px`;
        oLight.style.top = `${eLightY}px`;
    
        // Ajustement de l'ombre dynamique
        oDarkness.style.textShadow = `${30 - eLightX / 20}px ${-(eLightY / 15 - 25)}px 6px black`;
    });
    

    // cliquer 10 fois sur le corbeau
    document.addEventListener("DOMContentLoaded", function () {
        let corbeauS3 = document.getElementById("corbeauS3");
        let modalCorbeau = document.querySelector(".salle3__modal--corbeauS3");
        let closeModalButtonsCorbeau = document.querySelectorAll(".close-modal");
        let UseMirorCorbeau = document.querySelector(".UseMirorCorbeau");

        let clickCountCorbeau = 0;
        let clickTimeoutCorbeau;
        UseMirorCorbeau.style.display = "none";

        corbeauS3.addEventListener("click", function () {
            clickCountCorbeau++;
    
            // Réinitialise le compteur si pas de clic après 1 seconde
            clearTimeout(clickTimeoutCorbeau);
            clickTimeoutCorbeau = setTimeout(() => {
                clickCountCorbeau = 0;
            }, 1000);
    
            // Si 10 clics atteints, ouvrir la modale
            if (clickCountCorbeau >= 10) {
                modalCorbeau.classList.add("visible");
                //clickCountCorbeau = 0;
                UseMirorCorbeau.style.display = "inline-block";
            }
        });
    
        // Fermer la modale quand on clique sur un bouton de fermeture
        closeModalButtonsCorbeau.forEach(btn => {
            btn.addEventListener("click", function () {
                modalCorbeau.classList.remove("visible");
            });
        });
    });
    

    //lampe mooorse
    var morseMap = {
        0: '-----',
        1: '.----',
        2: '..---',
        3: '...--',
        4: '....-',
        5: '.....',
        6: '-....',
        7: '--...',
        8: '---..',
        9: '----.',
        a: '.-',
        b: '-...',
        c: '-.-.',
        d: '-..',
        e: '.',
        f: '..-.',
        g: '--.',
        h: '....',
        i: '..',
        j: '.---',
        k: '-.-',
        l: '.-..',
        m: '--',
        n: '-.',
        o: '---',
        p: '.--.',
        q: '--.-',
        r: '.-.',
        s: '...',
        t: '-',
        u: '..-',
        v: '...-',
        w: '.--',
        x: '-..-',
        y: '-.--',
        z: '--..'
        };
    var svgTopLight = document.getElementsByClassName('morse__svg--TL')[0];
    var svgBottomLight = document.getElementsByClassName('morse__svg--BL')[0];
    var keyboardButtons = document.getElementsByClassName('js-key');
    var keyCount = keyboardButtons.length;
    var lightUp = function (morseCodeChar, remainingCode) {
        svgTopLight.classList.add('light-up');
        svgBottomLight.classList.add('light-up');

        window.setTimeout(function() {
            svgTopLight.classList.remove('light-up');
            svgBottomLight.classList.remove('light-up');

            if (remainingCode) {
            window.setTimeout(function() {
                lightUp(remainingCode[0], remainingCode.substr(1, remainingCode.length));
            }, 500);
            } else {
            enableKeyboard();
            }
        }, morseCodeChar === '.' ? 300 : 1000);
    };

    var enableKeyboard = function (enable) {
        var isEnable = enable === undefined ? true : enable;
        
        for (var step = 0; step < keyCount; step++) {
            keyboardButtons[step].disabled = !isEnable;
        }
    };

    var keysStep, char, morseCode;

    for (keysStep = 0; keysStep < keyCount; keysStep++) {
        keyboardButtons[keysStep].addEventListener('click', function(e) {
            char = e.target.textContent;
            morseCode = morseMap[char];
            
            console.log(char + ': ' + morseCode);
            
            enableKeyboard(false);
            lightUp(morseCode[0], morseCode.substr(1, morseCode.length));
        });
    }


    // Input du moooorse cooode
    document.querySelector("#dotButtonMorse").addEventListener("click", function() {
        ajouterMorse(".");
    });
    
    document.querySelector("#dashButtonMorse").addEventListener("click", function() {
        ajouterMorse("-");
    });
    
    document.querySelector("#clearButtonMorse").addEventListener("click", function() {
        effacerMorse();
    });
    
    document.querySelector("#validateButtonMorse").addEventListener("click", function() {
        validerMorse();
    });
    
    function ajouterMorse(caractere) {
        let input = document.querySelector("#morseInput");
        input.value += caractere;
    }

    function effacerMorse() {
        document.querySelector("#morseInput").value = "";
        document.querySelector("#message").style.display = "none";
    }
    let nextMorse = document.querySelector(".nextMorse");
    nextMorse.style.display = "none";
    let UseInter = document.querySelector(".UseInter");
    UseInter.style.display = "none";



    function validerMorse() {
        let input = document.querySelector("#morseInput").value;
        if (input === ".....") {
            nextMorse.style.display = "inline-block";
            UseInter.style.display = "inline-block";
        } else {
            nextMorse.style.display = "none";
            showCustomAlert("As-tu bien pris le bon chiffre ? Le chiffre, pas le numéro ;)");
        }
    }


    // neoon
    let tumblerS3 = document.querySelector(".neon__tumbler"),
    toggleneonS3 = document.querySelector(".neon__toggle"),
    neonTittle = document.querySelector(".neon__tittle"),
    active = false;


    tumblerS3.addEventListener("click", function(){
        if (!active) {
            toggleneonS3.style.transform = "translateY(-10px) rotateX(180deg)";
            neonTittle.classList.add("neon__tittle--animate");
            active = true; 
        } else {
            toggleneonS3.style.transform = "translateY(0) rotateX(0)";
            neonTittle.classList.remove("neon__tittle--animate");
            neonTittle.classList.remove("neon__tittle--show");
            active = false;
        }
    });

    neonTittle.addEventListener("animationend", function(){
        neonTittle.classList.add("neon__tittle--show");
    });


    //heure et minute fragment 3
    let nextButtonS3 = document.querySelector(".nextFrags3");
    nextButtonS3.style.display = "none";
    
    document.querySelector(".theEnd__validate").addEventListener("click", function () {
        let heurelasts3 = document.querySelector(".theEnd__heure").value;
        let minutelasts3 = document.querySelector(".theEnd__min").value;
    
        if (heurelasts3 === "13" && minutelasts3 === "16") {
            nextButtonS3.style.display = "inline-block";
        }
        else {
            showCustomAlert("Cette heure n'est pas correcte. Ne prends pas en compte de l'heure de l'image.");
        }
    });
    
    
}

if (siSalle4) {

    function showCustomAlert(message) {
        const alertBox = document.querySelector('.customAlert');
        const alertMessage = document.querySelector('.customAlert__message');
        const okButton = document.querySelector('.customAlert__button');

        // Met à jour le message
        alertMessage.textContent = message;

        // Affiche l'alerte en enlevant la classe 'hidden'
        alertBox.classList.remove('hidden');

        // Événement de clic sur le bouton "Ok"
        okButton.addEventListener('click', () => {
            // Masque l'alerte en ajoutant la classe 'hidden'
            alertBox.classList.add('hidden');
        });
    }

    // //papiers déchirés
    const correctMapping = {
        1: "puzzle__piece--1", // haut gauche
        2: "puzzle__piece--2", // haut droite
        3: "puzzle__piece--3", // bas gauche
        4: "puzzle__piece--4", // bas droite
    };
      
    let draggedElement = null;
      
    document.querySelectorAll(".puzzles4__piece").forEach(piece => {
        piece.addEventListener("dragstart", e => {
        draggedElement = e.target;
        });
    });
      
    document.querySelectorAll(".puzzles4__dropzone").forEach(zone => {
        zone.addEventListener("dragover", e => {
            e.preventDefault();
            zone.style.backgroundColor = "#ffe";
        });
      
        zone.addEventListener("dragleave", () => {
            zone.style.backgroundColor = "#fff9e6";
        });
      
        zone.addEventListener("drop", () => {
            zone.style.backgroundColor = "#fff9e6";
            if (draggedElement) {
                // Clear previous content if any
                zone.innerHTML = "";
                zone.appendChild(draggedElement);
        
                checkPuzzle4();
            }
        });
    });
      
    function checkPuzzle4() {
        const allZones = document.querySelectorAll(".puzzles4__dropzone");
        let correct = true;
      
        allZones.forEach(zone => {
            const expectedClass = correctMapping[zone.dataset.zone];
            const img = zone.querySelector("img");
      
            if (!img || !img.classList.contains(expectedClass)) {
                correct = false;
            }
        });
      
        const message = document.querySelector(".puzzles4__message");
        if (correct) {
            document.querySelector('.nextPds4').classList.remove("none");
        } else {
          message.textContent = "";
        }
      }
      




    //grille de lettres enigme 2
    // const grilleLettres = document.querySelector('.grille__lettres');
    // const grilleDali = document.querySelector('.grille__dali');
    document.querySelector('#validateDali').addEventListener('click', () => {
        const inputDali = document.querySelector('#daliInput').value;
        const normalized = removeAccents(inputDali.trim().toLowerCase());
        const grilleLettres = document.querySelector('.grille__lettres');
        const grilleDali = document.querySelector('.grille__dali');
      
        if (normalized === 'dali') {
            document.querySelector('.nextgrille').classList.remove("none");
            grilleLettres.style.opacity = '0';
            grilleDali.style.opacity = '1';
        } else {
            showCustomAlert("Ce n'est pas le bon mot ! Prends les coordonnées dans le sens de lecture.");
        }
    });
      
    function removeAccents(str) {
        return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }



    //énigme 3 le coooffre
    const symbolesRs4 = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];

    document.querySelectorAll(".compteur__colonne").forEach((colonne) => {
        const valeurElRs4 = colonne.querySelector(".compteur__valeur");

        colonne.querySelector(".compteur__fleche--haut").addEventListener("click", () => {
            let current = valeurElRs4.textContent;
            let indexRs4 = symbolesRs4.indexOf(current);
            indexRs4 = (indexRs4 + 1) % symbolesRs4.length;
            valeurElRs4.textContent = symbolesRs4[indexRs4];
        });

        colonne.querySelector(".compteur__fleche--bas").addEventListener("click", () => {
            let current = valeurElRs4.textContent;
            let indexRs4 = symbolesRs4.indexOf(current);
            indexRs4 = (indexRs4 - 1 + symbolesRs4.length) % symbolesRs4.length;
            valeurElRs4.textContent = symbolesRs4[indexRs4];
        });
    });

    document.querySelector(".compteur__valider").addEventListener("click", () => {
    const lettresRs4 = Array.from(document.querySelectorAll(".compteur__valeur"))
        .map((el) => el.textContent.toLowerCase())
        .join("");

    if (lettresRs4 === "rene") {
        document.querySelector(".okRune").classList.remove("none");
    } else {
        showCustomAlert("La réponse pour cette énigme se trouve vraiment dans le titre d'une autre. À toi de voir laquelle...");
    }
    });
      
    

    //pigpen énigme 4
    const inputspigs4 = document.querySelectorAll(".pigpen__input");

    inputspigs4.forEach((input, index) => {
        input.addEventListener("input", (e) => {
            const letterpigs4 = e.target.value;

            // Autoriser seulement les lettres
            if (!/^[a-zA-Z]$/.test(letterpigs4)) {
                input.value = "";
                return;
            }

            input.value = letterpigs4.toLowerCase();

            // Aller à l'input suivant
            if (index < inputspigs4.length - 1) {
                inputspigs4[index + 1].focus();
            }
        });

        input.addEventListener("keydown", (e) => {
            if (e.key === "Backspace" && input.value === "" && index > 0) {
                inputspigs4[index - 1].focus();
            }
        });
    });

    document.querySelector(".pigpen__valider").addEventListener("click", () => {
        const valeurpigs4 = Array.from(inputspigs4).map(i => i.value).join("");
        if (valeurpigs4 === "distorsion") {
            document.querySelector(".pigpennext").classList.remove("none");
        } else {
            showCustomAlert("Le parchemin pour traduire se trouve dans le coffre...");
        }
    });




    //typewriter
    const outputTypes4 = document.querySelector(".machine__output");
    const keysTypes4 = document.querySelectorAll(".key");
    const validateBtnTypes4 = document.querySelector(".machine__valider");

    keysTypes4.forEach((key) => {
        key.addEventListener("click", () => {
            const value = key.textContent.trim();

            if (key.classList.contains("key--delete")) {
                outputTypes4.textContent = outputTypes4.textContent.slice(0, -1);
            } else if (key.classList.contains("key--space")) {
                outputTypes4.textContent += " ";
            } else {
                outputTypes4.textContent += value;
            }
        });
    });

    validateBtnTypes4.addEventListener("click", () => {
        if (outputTypes4.textContent.trim().toLowerCase() === "le temps est la cle") {
            document.querySelector(".okTypewriters4").classList.remove("none");
            document.querySelector(".machine").classList.add("none");
            document.querySelector(".fragsab4").classList.remove("none");
            document.querySelector(".modal__title--machine").textContent = "Le quatrième fragment";
        }
    });


    //random bg 
    const imagesbgs4 = [
        "assets/images/chapitres4/bgsalle41.webp",
        "assets/images/chapitres4/bg__salle42.webp"
    ];
    
    const randomImagebgs4 = imagesbgs4[Math.floor(Math.random() * imagesbgs4.length)];
    
    document.querySelector('.salle4__bg').src = randomImagebgs4;

}

if (siSalle5) {

    function showCustomAlert(message) {
        const alertBox = document.querySelector('.customAlert');
        const alertMessage = document.querySelector('.customAlert__message');
        const okButton = document.querySelector('.customAlert__button');

        // Met à jour le message
        alertMessage.textContent = message;

        // Affiche l'alerte en enlevant la classe 'hidden'
        alertBox.classList.remove('hidden');

        // Événement de clic sur le bouton "Ok"
        okButton.addEventListener('click', () => {
            // Masque l'alerte en ajoutant la classe 'hidden'
            alertBox.classList.add('hidden');
        });
    }

    //énimge 1
    document.addEventListener("DOMContentLoaded", () => {
        let cards_e1s5 = [];
        let matches_e1s5 = 0;
        const flipped_e1s5 = [];
      
        const build_board_e1s5 = () => {
            const board = document.querySelector(".memory__board");
            cards_e1s5 = get_cards_e1s5();
            board.innerHTML = cards_e1s5
                .map((card, id) => `
                <li class="memory__card cover" data-id="${id}e1s5" data-name="${card}e1s5">
                    <img src="assets/images/chapitres5/${card}.png" alt="${card}">
                </li>
                `).join("");
        
            board.addEventListener("click", flip_card_e1s5);
        };
      
        const flip_card_e1s5 = (e) => {
            const card = e.target.closest(".memory__card");
            if (!card || card.classList.contains("revealed") || card.classList.contains("is-match") || flipped_e1s5.length === 2) return;
        
                card.classList.add("revealed");
                flipped_e1s5.push({ card, name: card.dataset.name });
        
            if (flipped_e1s5.length === 2) check_match_e1s5();
        };
      
        const check_match_e1s5 = () => {
            const [first, second] = flipped_e1s5;
        
            if (first.name === second.name) {
                flipped_e1s5.forEach(({ card }) => card.classList.add("is-match"));
                matches_e1s5 += 2;
                flipped_e1s5.length = 0;
        
                if (matches_e1s5 === cards_e1s5.length) {
                    document.querySelector('.okMemos5').classList.remove('none');
                    matches_e1s5 = 0;
                    build_board_e1s5();
                }
            } else {
                setTimeout(() => {
                flipped_e1s5.forEach(({ card }) => card.classList.remove("revealed"));
                flipped_e1s5.length = 0;
                }, 800);
            }
        };
      
        const get_cards_e1s5 = () => {
            const base = ["silexs5", "prehis5", "papyruss5", "egyptes5", "epees5", "chateaus5", "machines5", "tempsmods5"];
            return shuffle_e1s5([...base, ...base]);
        };
      
        const shuffle_e1s5 = (array) => {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
            return array;
        };
      
        build_board_e1s5();
    });

    //énigme 2
    (function () {
        const correctOrdere2s5 = ['blue', 'gold','green', 'red'];
        let sequencee2s5 = [];
      
        const flaskButtons = document.querySelectorAll('.flask');
        const vessel = document.querySelector('.vessel__sand');
        const resulte2s5 = document.querySelector('.versSand__message');
        const sandSound = document.getElementById('sandSound');
      
        flaskButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                const colore2s5 = btn.dataset.color;
      
                if (sequencee2s5.length >= 4) return;
      
                sequencee2s5.push(colore2s5);
      
                // son du sable qu'on verse
                if (sandSound) {
                sandSound.currentTime = 0;
                sandSound.play().catch(e => console.log("Le son ne peut pas être joué sans interaction utilisateur :", e));
        
                setTimeout(() => {
                    sandSound.pause();
                    sandSound.currentTime = 0;
                }, 500);
                }
      
                // pour remplir
                vessel.style.height = `${sequencee2s5.length * 25}%`;
                vessel.style.backgroundImage = `${getGradient(sequencee2s5)}, url('../assets/images/chapitres5/noisy.jpg')`;
        
                if (sequencee2s5.length === 4) {
                checkSolution();
                }
            });
        });
      
        function checkSolution() {
            const isCorrecte2s5 = sequencee2s5.every((val, i) => val === correctOrdere2s5[i]);
          
            if (isCorrecte2s5) {
                document.querySelector('.okSabs5').classList.remove('none');
                document.querySelector('.okBuste').classList.remove('none');
                resulte2s5.classList.add('none'); // On cache le message d’erreur au cas où
            } else {
                resulte2s5.classList.remove('none');
                document.querySelector('.okSabs5').classList.add('none');
            }
          
            setTimeout(() => {
                sequencee2s5 = [];
                vessel.innerHTML = '';
                resulte2s5.classList.add('none');
            }, 2000);
        }
          
          
      
        function getGradient(sequencee2s5) {
            const colorse2s5 = {
                blue: '#2980B9',
                gold: '#FFD700',
                green: '#2ECC71',
                red: '#C0392B'
            };
          
            const gradientColorse2s5 = sequencee2s5
                .map(c => colorse2s5[c])
                .reverse()
                .join(', ');
            return `linear-gradient(to top, ${gradientColorse2s5})`;
        }
          
    })();


    //énigme 3
    document.querySelectorAll('.statue__choices').forEach(group => {
        group.querySelectorAll('button').forEach(btn => {
            btn.addEventListener('click', () => {
                group.querySelectorAll('button').forEach(b => b.classList.remove('selected'));
                btn.classList.add('selected');
            });
        });
    });
  
    document.querySelectorAll('.statue__button button').forEach(button => {
        button.addEventListener('click', () => {
            const riddleNumbere3s5 = parseInt(button.dataset.riddle, 10);
            const currente3s5 = document.querySelector(`#riddle${riddleNumbere3s5}`);
            let valide3s5 = false;
  
            if (riddleNumbere3s5 === 1) {
                const input3s5 = document.querySelector('#answer1');
                valide3s5 = input3s5.value.trim() === '210';
            } else {
                const selected3s5 = document.querySelector(`#riddle${riddleNumbere3s5} .statue__choices .selected`);
                const answer3s5 = selected3s5?.dataset.answer;
                if (riddleNumbere3s5 === 2) valide3s5 = answer3s5 === '3';
                if (riddleNumbere3s5 === 3) valide3s5 = answer3s5 === '2';
            }
  
            if (valide3s5) {
                currente3s5.classList.add('statue--hidden');
                const nexte3s5 = riddleNumbere3s5 === 3 ? '#successe3s5' : `#riddle${riddleNumbere3s5 + 1}`;
                const nextElemente3s5 = document.querySelector(nexte3s5);
                nextElemente3s5.classList.remove('statue--hidden');
                nextElemente3s5.classList.add('statue--enter');

                setTimeout(() => {
                    nextElemente3s5.classList.remove('statue--enter');
                }, 500);

            } else {
                showCustomAlert("Ce n'est pas la bonne réponse...");
            }
        });
    });



    //enigme 4
    let draggede4s5 = null;

    document.querySelectorAll('.batt__gear').forEach(gear => {
        gear.addEventListener('dragstart', e => {
            draggede4s5 = gear;
        });
    });

    document.querySelectorAll('.batt__slot').forEach(slot => {
        slot.addEventListener('dragover', e => {
            e.preventDefault();
            slot.classList.add('hover');
        });

        slot.addEventListener('dragleave', () => {
            slot.classList.remove('hover');
        });

        slot.addEventListener('drop', () => {
            slot.classList.remove('hover');
            if (draggede4s5) {
                slot.textContent = draggede4s5.textContent;
                slot.setAttribute('data-emotion', draggede4s5.dataset.emotion);
            }
        });
    });

    document.querySelector('#validateBtne4s5').addEventListener('click', () => {
        const expectede4s5 = {
            '00': 'peur',
            '03': 'espoir',
            '06': 'joie',
            '09': 'tristesse',
            '15': 'colere'
        };

        const correct4s5 = Object.entries(expectede4s5).every(([time, emotion]) => {
            const slot = document.querySelector(`.batt__slot[data-time="${time}"]`);
            return slot.dataset.emotion === emotion;
        });

        if (correct4s5) {
            document.querySelector('.goode4s5').classList.remove('none');
        } else {
            showCustomAlert("Cette combinaison n'est pas correcte...");
        }
    });


    //enigme 5
    const correctSigns = ['Balance', 'Bélier', 'Cancer', 'Capricorne'];
    const slots = document.querySelectorAll('.astro__slot');
    const buttonse5s5 = document.querySelectorAll('.astro__sign');
  
    buttonse5s5.forEach(btn => {
      btn.addEventListener('click', () => {
        const emptySlot = Array.from(slots).find(s => !s.textContent);
        if (emptySlot) {
          emptySlot.textContent = btn.dataset.sign;
          emptySlot.dataset.sign = btn.dataset.sign;
          btn.disabled = true;
        }
      });
    });
  
    document.getElementById('resetAstro').addEventListener('click', () => {
        slots.forEach(slot => {
            slot.textContent = '';
            delete slot.dataset.sign;
        });
        buttonse5s5.forEach(btn => btn.disabled = false);
    });
  
    document.getElementById('validateAstro').addEventListener('click', () => {
        const answere5s5 = Array.from(slots).map(s => s.dataset.sign);
        if (answere5s5.join(',') === correctSigns.join(',')) {
            document.querySelector('.okastro5').classList.remove('none');
        } else {
            showCustomAlert("Pense à mettre dans le bon ordre...");
        }
    });
      
}


if (siSalle6) {
    const piecesOrders6 = [1, 2, 3, 4, 5];
    let currentOrders6 = [...piecesOrders6];
    let firstSelectedPiece6 = null; // Pour la sélection au clic

    const containers6 = document.querySelector('#puzzleContainers6');
    const messages6 = document.querySelector('#successMessages6');
    const openButtons6 = document.querySelector('#openPuzzleButtons6');
    const modals6 = document.querySelector('#puzzleModals6');
    const closeButtons6 = document.querySelector('#closePuzzleModals6');
    const terminerButtons6 = document.querySelector('#terminerPuzzle6');

    const section1 = document.querySelector('#section1');
    const section2 = document.querySelector('#section2');
    const backgroundVideo2 = document.querySelector('#backgroundVideo2');
    const textAudio6 = document.querySelector('#textAudio6');
    const backgroundVideoDark = document.querySelector('#backgroundVideoDark');

    // Ouvre le puzzle
    openButtons6.addEventListener('click', () => {
        modals6.classList.remove('none');
        resetPuzzles6();
    });

    // Ferme le puzzle
    closeButtons6.addEventListener('click', () => {
        modals6.classList.add('none');
    });

    // Quand on termine
    terminerButtons6.addEventListener('click', () => {
        modals6.classList.add('none');
        section1.classList.add('none');
        section2.classList.remove('none');
        textAudio6.play();

        backgroundVideo2.onended = () => {
            backgroundVideoDark.play();
            backgroundVideoDark.style.opacity = '1';
            setTimeout(() => {
                backgroundVideo2.classList.add('none');
            }, 1000);
        };
    });

    function resetPuzzles6() {
        currentOrders6 = [...piecesOrders6];
        currentOrders6.sort(() => Math.random() - 0.5);
        renderPiecess6();
        messages6.style.display = 'none';
    }

    function renderPiecess6() {
        containers6.innerHTML = '';
        currentOrders6.forEach((num, index) => {
            const piece = document.createElement('div');
            piece.className = 'puzzles6__piece';
            piece.style.backgroundImage = `url('../assets/images/chapitres6/fragsabs1${num}.webp')`;
            piece.setAttribute('data-index', index);
            piece.setAttribute('draggable', true);

            // Drag & Drop
            piece.addEventListener('dragstart', (e) => {
                e.dataTransfer.setData('text/plain', index);
            });

            piece.addEventListener('dragover', (e) => {
                e.preventDefault();
            });

            piece.addEventListener('drop', (e) => {
                const fromIndex = e.dataTransfer.getData('text/plain');
                const toIndex = piece.getAttribute('data-index');
                swapPiecess6(fromIndex, toIndex);
            });

            // Clic pour échange
            piece.addEventListener('click', () => {
                if (!firstSelectedPiece6) {
                    firstSelectedPiece6 = piece;
                    piece.classList.add('selected');
                } else {
                    const fromIndex = firstSelectedPiece6.getAttribute('data-index');
                    const toIndex = piece.getAttribute('data-index');
                    firstSelectedPiece6.classList.remove('selected');
                    firstSelectedPiece6 = null;
                    swapPiecess6(fromIndex, toIndex);
                }
            });

            containers6.appendChild(piece);
        });
    }

    function swapPiecess6(from, to) {
        const temp = currentOrders6[from];
        currentOrders6[from] = currentOrders6[to];
        currentOrders6[to] = temp;
        renderPiecess6();
        checkSuccesss6();
    }

    function checkSuccesss6() {
        const isCorrects6 = currentOrders6.every((num, i) => num === piecesOrders6[i]);
        messages6.style.display = isCorrects6 ? 'block' : 'none';
    }

    document.addEventListener('DOMContentLoaded', renderPiecess6);

    textAudio6.addEventListener('ended', () => {
        textAudio6.src = 'assets/sons/justmusic6.mp3';
        textAudio6.loop = true;
        textAudio6.load();
        textAudio6.play();
    });
}
